export enum StringId {
  DV_TW_title_subtitles,
  DV_TW_title_languages,
  DV_TW_title_mpaarating,
  DV_TW_title_bbfcrating,
  DV_TW_title_fskrating,
  DV_TW_title_eirinrating,
  DV_TW_title_director,
  DV_TW_title_producers,
  DV_TW_title_actors,
  DV_TW_title_starring,
  DV_TW_title_genres,
  DV_TW_title_studio,
  DV_TW_title_network,
  DV_TW_title_amr,
  DV_TW_title_devices,
  DV_DP_learn_more,
  DV_TW_title_seasonyear,
  DV_TW_title_purchaserights,
  DV_TW_data_purchaserights_streaming,
  DV_TW_data_available_to_watch_devices,
  DV_TW_Detail_text,
  DV_TW_title_format,
  DV_TW_data_format_streaming,
  DV_comma_separator,
  DV_MWTW_TITLE,
  DV_MWTW_TITLE_MAIN,
  DV_RBB_CANCEL_PURCH_MODAL_HEADER,
  DV_RBB_CANCEL_PURCH_MODAL_SUBMIT,
  DV_AB_CANCEL_ACCIDENTAL_PURCHASE,
  DV_DP_EL_episode_title_template,
  DV_DP_EL_bonus_title_template,
  AVOD_DP_redeem_gift_card_or_promotion,
  DV_DP_more_details,
  DV_DP_more_items,
  DV_DP_unavailable_episode_list_message,
  DV_brand_av,
  DV_DP_live_badge_text,
  DV_WEB_DP_popover_purchase_rights,
  AVOD_DP_season_selector,
  DV_DP_first_review,
  DV_DP_COMING_SOON_MESSAGE,
  DV_DP_COMING_SOON_TBC_DATE,
  DV_DP_COMING_IN_YEAR_MESSAGE,
  DV_DP_Watchlist_toggle_label,
  DV_DP_WL_removeMovie,
  DV_DP_WL_removeTv,
  DV_DP_WL_addMovie,
  DV_DP_WL_addTv,
  DV_DP_WL_addTvProcessing,
  DV_DP_WL_removeTvProcessing,
  DV_WEB_PAGINATION_PAGE,
  DV_WEB_PAGINATION_PREVIOUS,
  DV_WEB_PAGINATION_NEXT,
  DV_DP_see_more,
  DV_DP_title_num_of_seasons_one,
  DV_DP_title_num_of_seasons_few,
  DV_DP_title_num_of_seasons_many,
  DV_DP_title_num_of_seasons_other,
  DV_DP_unavailable_page_message,
  DV_DP_only_playback_available_in_gen4_message,
  DV_DP_ARIA_amazon_rating,
  DV_DP_ARIA_imdb_rating,
  DV_DP_ARIA_watch_episode,
  DV_DP_ARIA_watch_title,
  DV_DP_ARIA_learn_more_amr,
  AVOD_DP_E_error_text,
  AVOD_DP_E_error_ok,
  DV_DP_CAST_CREW_HEADING,
  AVOD_WL_error_msg,
  DV_DP_ARIA_audio_description,
  DV_DP_CL_other_formats_title
}
